import { render, staticRenderFns } from "./SessionDiscountSlices.vue?vue&type=template&id=470efc81&"
import script from "./SessionDiscountSlices.vue?vue&type=script&lang=js&"
export * from "./SessionDiscountSlices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports